import * as React from 'react';

import Grid from '@mui/material/Grid';
import Slide from '@mui/material/Slide';
import Dialog from '@mui/material/Dialog';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import { TransitionProps } from '@mui/material/transitions';

// ----------------------------------------------------------------------

const Transition = React.forwardRef(
  (
    props: TransitionProps & {
      children: React.ReactElement<unknown>;
    },
    ref: React.Ref<unknown>
  ) => <Slide direction="up" ref={ref} {...props} />
);

type CombinedFormFillingDialogProps = {
  isCombinedMode: boolean;
  setIsCombinedMode: React.Dispatch<React.SetStateAction<boolean>>;
  documentName: string;
  form: React.ReactElement;
  mainDocument: React.ReactElement;
};

const CombinedFormFillingDialog: React.FC<CombinedFormFillingDialogProps> = ({
  isCombinedMode,
  setIsCombinedMode,
  documentName,
  form,
  mainDocument,
}) => {
  const handleClose = () => {
    setIsCombinedMode(false);
  };

  return (
    <Dialog
      fullScreen
      open={isCombinedMode}
      onClose={handleClose}
      slots={{
        transition: Transition,
      }}
    >
      <AppBar sx={{ position: 'relative' }}>
        <Toolbar>
          <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
            {documentName}
          </Typography>

          <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
            <CloseIcon />
          </IconButton>
        </Toolbar>
      </AppBar>

      <Grid container spacing={2} sx={{ p: 2 }}>
        <Grid size={{ xs: 12, lg: 6 }}>{form}</Grid>

        <Grid size={{ xs: 12, lg: 6 }}>{mainDocument}</Grid>
      </Grid>
    </Dialog>
  );
};

export default CombinedFormFillingDialog;
